import React from 'react'
import createReactClass from 'create-react-class'

import i18n from 'live/services/i18n'
import ActionConfirmationDialog from 'live/components/actions/ui/confirmation-dialog'

module.exports = createReactClass({
    displayName: 'TestWarningDialog',
    render () {
        return (
            <ActionConfirmationDialog
                show={this.props.show}
                onHide={this.props.onHide}
                className="modal-sm modal-error"
                content={
                    <p>
                        <strong>{i18n('We found errors in the form')}.</strong>
                        <br />
                        <span>{i18n('Please correct the errors and try again')}.</span>
                    </p>
                }
                btnText={i18n('ok')}
                disableCancel={true}
                apply={this.props.onHide}
            />
        )
    }
})
